"use client";

import {
  startTransition,
  useActionState,
  useCallback,
  useEffect,
  useMemo
} from "react";

import { backOfficeActions } from "@/backoffice/actions";
import { useLayout } from "@/providers";
import { MenuContext } from "./MenuContext";
import SidebarHovered from "./SidebarHovered";

import type { FetchParams, MenuItem, RequestResponse } from "@/types";
import type { JSX } from "react";

const AsideMenu = (): JSX.Element => {
  const { sidebarIsOpen, setSidebarIsOpen } = useLayout();
  const [menuStatus, getMenu, isPending] = useActionState<
    RequestResponse<MenuItem[]> | null,
    FetchParams
  >(backOfficeActions, null);
  const refetch = useCallback(() => {
    startTransition(() => {
      getMenu({ url: "auth/menu" });
    });
  }, [getMenu]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  const value = useMemo(
    () => ({
      data: (menuStatus?.["auth/menu"] as MenuItem[]) || [],
      sidebarIsOpen,
      setSidebarIsOpen,
      refetch
    }),
    [menuStatus, isPending, refetch]
  );

  return (
    <MenuContext.Provider value={value}>
      <SidebarHovered />
    </MenuContext.Provider>
  );
};

export default AsideMenu;
